import { useTheme } from '../context/ThemeContext.jsx'

const NEXT = { system: 'light', light: 'dark', dark: 'system' }
const LABEL = { system: 'System theme', light: 'Light theme', dark: 'Dark theme' }
const GLYPH = { system: '◐', light: '☀', dark: '☾' }

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme()
  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={() => setTheme(NEXT[theme])}
      // The glyph alone is not a label, and the control cycles rather than
      // toggles, so the accessible name says where it goes next.
      aria-label={`${LABEL[theme]}. Switch to ${LABEL[NEXT[theme]].toLowerCase()}`}
      title={LABEL[theme]}
    >
      <span aria-hidden="true">{GLYPH[theme]}</span>
    </button>
  )
}
